(function () {
  function safeTag(tag, fallback) {
    const allowed = new Set(["p", "h2", "h3", "h4", "h5", "h6", "div", "span"]);
    const t = String(tag || "").toLowerCase().trim();
    return allowed.has(t) ? t : fallback;
  }

  function toPx(n) {
    const v = Number(n);
    return Number.isFinite(v) ? `${v}px` : "";
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function pageHTML(page, side, opts) {
    const p = page || {};
    const type = String(p.type || "content").toLowerCase().trim();

    if (type === "app") {
      const id = String(p.app_id || "").trim();
      return `<div class="jl-page-inner">
        <div class="jl-body jl-app-body">
          <div class="jl-app-slot" data-jl-app-slot="${id}"></div>
          <div class="jl-footer"></div>
        </div>
      </div>`;
    }

    const isCover = !!(opts && opts.cover === true);

    const hasImg = !!p.image;
    const mediaClass =
      isCover ? "jl-cover-media" : (side === "right" ? "jl-media jl-media--bottom" : "jl-media jl-media--top");

    const img = hasImg
      ? `<div class="${mediaClass}">
           <img class="jl-img" src="${p.image}" alt="" loading="eager" decoding="async">
         </div>`
      : "";

    const kickerTag = safeTag(p.kicker_tag, "p");
    const headingTag = safeTag(p.heading_tag, "h3");

    const kicker = p.kicker ? `<${kickerTag} class="jl-kicker">${p.kicker}</${kickerTag}>` : "";
    const heading = p.heading ? `<${headingTag} class="jl-heading">${p.heading}</${headingTag}>` : "";
    const text = p.text ? `<div class="jl-text rte">${p.text}</div>` : "";
    const cta =
      p.cta_label && p.cta_link
        ? `<a class="jl-cta button button--primary" href="${p.cta_link}">${p.cta_label}</a>`
        : "";

    const kickerPx = toPx(p.kicker_px);
    const headingPx = toPx(p.heading_px);
    const bodyPx = toPx(p.body_px);

    const styleVars = [
      kickerPx ? `--jl-kicker:${kickerPx};` : "",
      headingPx ? `--jl-heading:${headingPx};` : "",
      bodyPx ? `--jl-body:${bodyPx};` : ""
    ].join("");

    if (isCover) {
      return `
        <div class="jl-page-inner jl-cover-inner" style="${styleVars}">
          ${img}
          <div class="jl-body">
            ${kicker}${heading}${text}${cta}
            <div class="jl-footer"></div>
          </div>
        </div>
      `;
    }

    const body = `<div class="jl-body">${kicker}${heading}${text}${cta}<div class="jl-footer"></div></div>`;
    const inner = side === "right" ? `${body}${img}` : `${img}${body}`;

    return `<div class="jl-page-inner" style="${styleVars}">${inner}</div>`;
  }

  function initSection(section) {
    if (!section || section.__jlInit) return;
    section.__jlInit = true;

    const key = section.getAttribute("data-jl-key") || "jl";
    const storageKey = `jl_state_${key}`;

    const dataEl = section.querySelector("[data-jl-data]");
    const leftEl = section.querySelector("[data-jl-left]");
    const rightEl = section.querySelector("[data-jl-right]");

    const flipEl = section.querySelector("[data-jl-flip]");
    const flipFront = section.querySelector("[data-jl-flip-front]");
    const flipBack = section.querySelector("[data-jl-flip-back]");

    const coverEl = section.querySelector("[data-jl-cover]");
    const coverSheet = section.querySelector("[data-jl-cover-sheet]");
    const coverFront = section.querySelector("[data-jl-cover-front]");
    const coverBack = section.querySelector("[data-jl-cover-back]");

    const btnPrev = section.querySelector("[data-jl-prev]");
    const btnNext = section.querySelector("[data-jl-next]");
    const currentEl = section.querySelector("[data-jl-current]");
    const totalEl = section.querySelector("[data-jl-total]");

    const appBank = section.querySelector("[data-jl-app-bank]");

    if (!dataEl || !leftEl || !rightEl || !flipEl || !flipFront || !flipBack) return;

    let raw = [];
    try {
      raw = JSON.parse((dataEl.textContent || "").trim());
    } catch (e) {
      console.error("Flipbook JSON parse error:", e);
      return;
    }
    if (!Array.isArray(raw) || raw.length === 0) return;

    const first = raw[0];
    const hasCover = String(first?.type || "").toLowerCase() === "cover" && first?.cover;
    const coverData = hasCover ? first.cover : null;
    const spreads = hasCover ? raw.slice(1) : raw;

    if (!Array.isArray(spreads) || spreads.length === 0) return;

    const mm = window.matchMedia("(max-width: 860px)");
    const flipMs = Number(section.getAttribute("data-flip-ms")) || 950;

    // Build pages list for mobile
    const pages = [];
    spreads.forEach((s) => {
      pages.push({ side: "left", data: s.left, spread: s });
      pages.push({ side: "right", data: s.right, spread: s });
    });

    // Build app map
    const appMap = new Map();
    if (appBank) {
      appBank.querySelectorAll("[data-jl-app-bank-id]").forEach((node) => {
        const id = node.getAttribute("data-jl-app-bank-id");
        if (id) appMap.set(id, node);
      });
    }

    function visibleAppsForSpread(s) {
      const set = new Set();
      if (String(s.left?.type || "content").toLowerCase() === "app" && s.left?.app_id) set.add(String(s.left.app_id).trim());
      if (String(s.right?.type || "content").toLowerCase() === "app" && s.right?.app_id) set.add(String(s.right.app_id).trim());
      return set;
    }

    function syncApps(visibleIds) {
      if (!appBank) return;

      section.querySelectorAll("[data-jl-app-slot]").forEach((slot) => {
        const id = slot.getAttribute("data-jl-app-slot");
        if (!id) return;

        if (!visibleIds.has(id)) {
          slot.innerHTML = "";
          return;
        }

        const appNode = appMap.get(id);
        if (!appNode) {
          slot.innerHTML = `<div style="opacity:.7;font-size:12px;">App block not found: ${id}</div>`;
          return;
        }

        slot.innerHTML = "";
        slot.appendChild(appNode);
      });

      appMap.forEach((node, id) => {
        if (visibleIds.has(id)) return;
        if (node.parentElement !== appBank) appBank.appendChild(node);
      });
    }

    // Preload images
    const seen = new Set();
    if (coverData?.image) {
      seen.add(coverData.image);
      const img = new Image();
      img.src = coverData.image;
    }
    spreads.forEach((s) => {
      ["left", "right"].forEach((side) => {
        const p = s?.[side] || {};
        if (String(p.type || "content").toLowerCase() !== "content") return;
        const url = p.image;
        if (url && !seen.has(url)) {
          seen.add(url);
          const img = new Image();
          img.src = url;
        }
      });
    });

    function setSpeed(ms) {
      section.style.setProperty("--jl-flip-ms", `${ms}ms`);
      section.style.setProperty("--jl-cover-ms", `${ms}ms`);
    }

    function isInteractiveTarget(t) {
      return !!t.closest("a, button, input, textarea, select, label, [role='button']");
    }

    // ---- State persistence ----
    function readState() {
      try {
        const s = JSON.parse(sessionStorage.getItem(storageKey) || "{}");
        return {
          coverOpen: !!s.coverOpen,
          spreadIndex: Number.isFinite(s.spreadIndex) ? s.spreadIndex : 0,
          pageIndex: Number.isFinite(s.pageIndex) ? s.pageIndex : 0
        };
      } catch {
        return { coverOpen: !hasCover, spreadIndex: 0, pageIndex: 0 };
      }
    }

    function writeState() {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({
          coverOpen,
          spreadIndex,
          pageIndex
        }));
      } catch {}
    }

    // defaults
    let animating = false;

    // restore
    const restored = readState();
    let coverOpen = hasCover ? restored.coverOpen : true;
    let spreadIndex = clamp(restored.spreadIndex, 0, Math.max(0, spreads.length - 1));
    let pageIndex = clamp(restored.pageIndex, 0, Math.max(0, pages.length - 1));

    function renderDesktop(i) {
      const s = spreads[i];
      leftEl.innerHTML = pageHTML(s.left, "left");
      rightEl.innerHTML = pageHTML(s.right, "right");
      syncApps(visibleAppsForSpread(s));
    }

    function renderMobileStatic() {
      rightEl.innerHTML = "";
      const p = pages[pageIndex];
      leftEl.innerHTML = pageHTML(p.data, p.side);
      syncApps(visibleAppsForSpread(p.spread));
    }

    // ---- Cover overlay render + open/close ----
    function renderCover() {
      if (!hasCover || !coverEl || !coverFront || !coverBack) return;

      coverFront.innerHTML = pageHTML(coverData, "cover", { cover: true });
      coverBack.innerHTML = `<div class="jl-cover-backfill"></div>`;

      if (!coverOpen) {
        coverEl.classList.add("is-visible");
        coverEl.classList.remove("is-open");
      } else {
        coverEl.classList.remove("is-visible");
        coverEl.classList.add("is-open");
      }
    }

    function openCover() {
      if (!hasCover || coverOpen || animating) return;
      if (!coverEl || !coverSheet) {
        coverOpen = true;
        writeState();
        renderCover();
        return;
      }

      animating = true;
      setSpeed(flipMs);

      // ensure spread beneath is already rendered
      if (mm.matches) renderMobileStatic();
      else renderDesktop(spreadIndex);

      coverEl.classList.add("is-visible");
      coverEl.classList.remove("is-open");

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          coverEl.classList.add("is-open"); // animates open
        });
      });

      const done = () => {
        coverOpen = true;
        coverEl.classList.remove("is-visible"); // hide after open (so it doesn't sit there)
        animating = false;
        writeState();
        updateControls();
      };

      const onEnd = (e) => {
        if (e.propertyName !== "transform") return;
        coverSheet.removeEventListener("transitionend", onEnd);
        clearTimeout(tid);
        done();
      };

      coverSheet.addEventListener("transitionend", onEnd);
      const tid = window.setTimeout(() => {
        coverSheet.removeEventListener("transitionend", onEnd);
        done();
      }, flipMs + 140);
    }

    function closeCover() {
      if (!hasCover || !coverOpen || animating) return;
      if (!coverEl || !coverSheet) {
        coverOpen = false;
        writeState();
        renderCover();
        return;
      }

      animating = true;
      setSpeed(flipMs);

      // show overlay in open position, then animate shut
      coverEl.classList.add("is-visible");
      coverEl.classList.add("is-open");

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          coverEl.classList.remove("is-open"); // animates closed
        });
      });

      const done = () => {
        coverOpen = false;
        // keep visible when closed so you can see cover
        coverEl.classList.add("is-visible");
        animating = false;
        writeState();
        updateControls();
      };

      const onEnd = (e) => {
        if (e.propertyName !== "transform") return;
        coverSheet.removeEventListener("transitionend", onEnd);
        clearTimeout(tid);
        done();
      };

      coverSheet.addEventListener("transitionend", onEnd);
      const tid = window.setTimeout(() => {
        coverSheet.removeEventListener("transitionend", onEnd);
        done();
      }, flipMs + 140);
    }

    function totalCount() {
      return spreads.length + (hasCover ? 1 : 0);
    }

    function updateControls() {
      if (mm.matches) {
        // Mobile: cover is page 1, then content pages
        const cur = hasCover && !coverOpen ? 1 : (hasCover ? 1 + (pageIndex + 1) : (pageIndex + 1));
        const tot = (hasCover ? 1 : 0) + pages.length;
        if (currentEl) currentEl.textContent = String(cur);
        if (totalEl) totalEl.textContent = String(tot);

        if (btnPrev) btnPrev.disabled = hasCover && !coverOpen;
        if (btnNext) btnNext.disabled = (hasCover && !coverOpen) ? false : pageIndex >= pages.length - 1;
      } else {
        // Desktop: cover is 1, then spreads
        const cur = hasCover && !coverOpen ? 1 : (hasCover ? 1 + (spreadIndex + 1) : (spreadIndex + 1));
        if (currentEl) currentEl.textContent = String(cur);
        if (totalEl) totalEl.textContent = String(totalCount());

        if (btnPrev) btnPrev.disabled = hasCover && !coverOpen;
        if (btnNext) btnNext.disabled = (hasCover && !coverOpen) ? false : spreadIndex >= spreads.length - 1;
      }
    }

    // ---- Normal flips ----
    function desktopNext() {
      if (hasCover && !coverOpen) return openCover();
      if (animating || spreadIndex >= spreads.length - 1) return;

      animating = true;
      setSpeed(flipMs);

      const cur = spreads[spreadIndex];
      const nxt = spreads[spreadIndex + 1];

      rightEl.innerHTML = pageHTML(nxt.right, "right");

      flipEl.classList.remove("dir-prev", "is-turning");
      flipEl.classList.add("is-active", "dir-next");

      flipFront.innerHTML = pageHTML(cur.right, "right");
      flipBack.innerHTML = pageHTML(nxt.left, "left");

      requestAnimationFrame(() => requestAnimationFrame(() => flipEl.classList.add("is-turning")));

      const done = () => {
        flipEl.classList.remove("is-turning", "is-active", "dir-next");
        flipFront.innerHTML = "";
        flipBack.innerHTML = "";
        spreadIndex += 1;
        renderDesktop(spreadIndex);
        animating = false;
        writeState();
        updateControls();
      };

      const onEnd = (e) => {
        if (e.propertyName !== "transform") return;
        flipEl.removeEventListener("transitionend", onEnd);
        clearTimeout(tid);
        done();
      };

      flipEl.addEventListener("transitionend", onEnd);
      const tid = window.setTimeout(() => {
        flipEl.removeEventListener("transitionend", onEnd);
        done();
      }, flipMs + 140);
    }

    function desktopPrev() {
      if (hasCover && !coverOpen) return;
      if (spreadIndex === 0 && hasCover && coverOpen) return closeCover();
      if (animating || spreadIndex <= 0) return;

      animating = true;
      setSpeed(flipMs);

      const cur = spreads[spreadIndex];
      const prv = spreads[spreadIndex - 1];

      leftEl.innerHTML = pageHTML(prv.left, "left");

      flipEl.classList.remove("dir-next", "is-turning");
      flipEl.classList.add("is-active", "dir-prev");

      flipFront.innerHTML = pageHTML(cur.left, "left");
      flipBack.innerHTML = pageHTML(prv.right, "right");

      requestAnimationFrame(() => requestAnimationFrame(() => flipEl.classList.add("is-turning")));

      const done = () => {
        flipEl.classList.remove("is-turning", "is-active", "dir-prev");
        flipFront.innerHTML = "";
        flipBack.innerHTML = "";
        spreadIndex -= 1;
        renderDesktop(spreadIndex);
        animating = false;
        writeState();
        updateControls();
      };

      const onEnd = (e) => {
        if (e.propertyName !== "transform") return;
        flipEl.removeEventListener("transitionend", onEnd);
        clearTimeout(tid);
        done();
      };

      flipEl.addEventListener("transitionend", onEnd);
      const tid = window.setTimeout(() => {
        flipEl.removeEventListener("transitionend", onEnd);
        done();
      }, flipMs + 140);
    }

    function mobileFlipTo(nextIndex, dir) {
      if (hasCover && !coverOpen) return openCover();
      if (animating) return;

      animating = true;
      setSpeed(flipMs);

      const cur = pages[pageIndex];
      const nxt = pages[nextIndex];

      rightEl.innerHTML = "";
      leftEl.innerHTML = pageHTML(nxt.data, nxt.side);

      flipEl.classList.remove("dir-next", "dir-prev", "is-turning");
      flipEl.classList.add("is-active", dir === "next" ? "dir-next" : "dir-prev");

      flipFront.innerHTML = pageHTML(cur.data, cur.side);
      flipBack.innerHTML = pageHTML(nxt.data, nxt.side);

      requestAnimationFrame(() => requestAnimationFrame(() => flipEl.classList.add("is-turning")));

      const done = () => {
        flipEl.classList.remove("is-turning", "is-active", "dir-next", "dir-prev");
        flipFront.innerHTML = "";
        flipBack.innerHTML = "";
        pageIndex = nextIndex;
        renderMobileStatic();
        animating = false;
        writeState();
        updateControls();
      };

      const onEnd = (e) => {
        if (e.propertyName !== "transform") return;
        flipEl.removeEventListener("transitionend", onEnd);
        clearTimeout(tid);
        done();
      };

      flipEl.addEventListener("transitionend", onEnd);
      const tid = window.setTimeout(() => {
        flipEl.removeEventListener("transitionend", onEnd);
        done();
      }, flipMs + 140);
    }

    function mobileNext() {
      if (hasCover && !coverOpen) return openCover();
      if (pageIndex >= pages.length - 1) return;
      mobileFlipTo(pageIndex + 1, "next");
    }

    function mobilePrev() {
      if (hasCover && !coverOpen) return;
      if (pageIndex === 0 && hasCover && coverOpen) return closeCover();
      if (pageIndex <= 0) return;
      mobileFlipTo(pageIndex - 1, "prev");
    }

    function goNext() {
      return mm.matches ? mobileNext() : desktopNext();
    }

    function goPrev() {
      return mm.matches ? mobilePrev() : desktopPrev();
    }

    const stageEl = section.querySelector(".jl-stage");
    if (stageEl) {
      stageEl.addEventListener("click", (e) => {
        if (isInteractiveTarget(e.target)) return;
        if (hasCover && !coverOpen) return openCover();

        const rect = stageEl.getBoundingClientRect();
        const x = e.clientX - rect.left;
        if (x < rect.width / 2) goPrev();
        else goNext();
      });
    }

    if (btnNext) btnNext.addEventListener("click", goNext);
    if (btnPrev) btnPrev.addEventListener("click", goPrev);

    function initRender() {
      setSpeed(flipMs);

      // render content first
      if (mm.matches) {
        pageIndex = clamp(pageIndex, 0, pages.length - 1);
        renderMobileStatic();
      } else {
        spreadIndex = clamp(spreadIndex, 0, spreads.length - 1);
        renderDesktop(spreadIndex);
      }

      // then cover on top (closed/open restored)
      renderCover();
      updateControls();
      writeState();
    }

    initRender();

    const onChange = () => initRender();
    if (mm.addEventListener) mm.addEventListener("change", onChange);
    else mm.addListener(onChange);
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-jl-section]").forEach(initSection);
  });

  document.addEventListener("shopify:section:load", (e) => {
    const root = e.target;
    if (root.matches?.("[data-jl-section]")) initSection(root);
    root.querySelectorAll?.("[data-jl-section]")?.forEach(initSection);
  });
})();
